/**
 * @generated SignedSource<<6e2b719e7f5df6fabc9fc62b1e3980c8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Row481BadPattern$data = {
  readonly " $fragmentSpreads": FragmentRefs<"IssueRow336BadPattern" | "useRowColor">;
  readonly " $fragmentType": "Row481BadPattern";
};
export type Row481BadPattern$key = {
  readonly " $data"?: Row481BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"Row481BadPattern">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isLinkRelationshipFieldEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isTimelineEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "Row481BadPattern",
  "selections": [
    {
      "condition": "isConditionalFormattingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "useRowColor"
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        },
        {
          "kind": "Variable",
          "name": "isDensityFull",
          "variableName": "isDensityFull"
        },
        {
          "kind": "Variable",
          "name": "isInlineEditingEnabled",
          "variableName": "isInlineEditingEnabled"
        },
        {
          "kind": "Variable",
          "name": "isLinkRelationshipFieldEnabled",
          "variableName": "isLinkRelationshipFieldEnabled"
        },
        {
          "kind": "Variable",
          "name": "isTimelineEnabled",
          "variableName": "isTimelineEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "IssueRow336BadPattern"
    }
  ],
  "type": "JiraIssueFieldSetConnection"
};

(node as any).hash = "fba47e42247840cf0be376007d82f038";

export default node;
